require('./brokerConvenienceMiFIDTestInvalidAnswersModal.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');

const BrokerConvenienceMiFIDTestInvalidAnswersModal = ({
        isVisible,
        onClose,
        title,
        message,
        onVerifyClick
}) => {
    const modalContent = (
        <section className="text-left">
            <div className="broker-convenience-mifid-test-invalid-answers-modal__message">
                {title}
            </div>
            <div className="broker-convenience-mifid-test-invalid-answers-modal__message">
                {message}
            </div>
        </section>
    );

    return (
        <OKModal
            content={modalContent}
            footerType="navigation"
            isOpen={isVisible}
            onCloseCallback={onClose}
            onPrimaryButtonClick={onVerifyClick}
            primaryButtonText="broker-convenienceMifidTestInvalidAnswerModalVerify"
            shouldCloseOnOverlayClick={false}
            title="broker-convenienceMifidTestInvalidAnswerModalTitle"
        />
    );
};

BrokerConvenienceMiFIDTestInvalidAnswersModal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    onVerifyClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string
};

module.exports = BrokerConvenienceMiFIDTestInvalidAnswersModal;
